// Compact trip title, e.g. "Flughafen Zürich (ZRH), ..." + "Blumenfeldstrasse 1, 8046 Zürich"
// -> "Flughafen Zürich > Zürich". Used in ratings / customer-facing trip display.
export function shortPlace(addr) {
  if (!addr) return "";
  let s = String(addr).replace(/\s*\([^)]*\)\s*/g, " ").trim(); // drop "(ZRH)" etc.
  if (/flughafen|airport|aéroport|aeroporto|aeropuerto/i.test(s)) return "Flughafen Zürich";
  const parts = s
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean)
    .filter((x) => !/^(schweiz|switzerland|suisse|svizzera|deutschland|germany|österreich|austria|france|italia|italy|liechtenstein)$/i.test(x));
  let last = parts[parts.length - 1] || s;
  last = last.replace(/\b\d{4,6}\b/g, "").trim(); // strip postal code
  if (!last && parts.length >= 2) last = parts[parts.length - 2].replace(/\b\d{4,6}\b/g, "").trim();
  return last || s;
}

export function routeTitle(pickup, dropoff) {
  const a = shortPlace(pickup);
  const b = shortPlace(dropoff);
  if (!b) return a;
  if (!a) return b;
  return `${a} > ${b}`;
}
